import { RootState } from "@/redux/store";

export const bulkImportReportSelector = (state: RootState) => state.bulkImportReport;
